module.exports = __webpack_public_path__ + "static/media/orange03.62675fe8.svg";